export const ACTIVITY_TYPE_OPTIONS = [
  { value: "development", label: "Development" },
  { value: "testing", label: "Testing" },
  { value: "design", label: "Design" },
  { value: "review", label: "Review" },
  { value: "meeting", label: "Meeting" },
  { value: "documentation", label: "Documentation" },
  { value: "deployment", label: "Deployment" },
  { value: "support", label: "Support" },
  { value: "training", label: "Training" },
  { value: "travel", label: "Travel" },
  { value: "admin", label: "Admin" },
];

// Color hex values for activity type dot indicators (T56, T58)
export const ACTIVITY_TYPE_COLORS = {
  development: "#0F1B3D",
  testing: "#8b5cf6",
  design: "#ec4899",
  review: "#f59e0b",
  meeting: "#10b981",
  documentation: "#06b6d4",
  deployment: "#3b82f6",
  support: "#f97316",
  training: "#84cc16",
  travel: "#6b7280",
  admin: "#6b7280",
};

// Category accent colours — §7a.2 series mapping (CSS vars flip with theme)
export const CATEGORY_COLORS = {
  // Legacy flat categories
  development: "var(--series-1)",
  service: "var(--series-2)",
  deployment: "var(--series-5)",
  maintenance: "var(--series-4)",
  sales: "var(--series-6)",
  other: "var(--brand-steel)",
  // M6 service catalog quadrant slugs (must match server.py ServiceQuadrant.quadrant values)
  change: "var(--series-1)",
  engineering_service: "var(--series-2)",
  operation: "var(--series-3)",
  project_engineering_common: "var(--series-4)",
  soe: "var(--series-5)",
  support: "var(--series-6)",
};
